export default __webpack_public_path__ + "static/media/arrow-left.a695b2e4.svg";